import { Moment } from 'moment';
import { ChatId } from '@/chat/models/ids';
import Customer from '@/customer/models/Customer';
import Dossier from '@/dossier/models/Dossier';
import ChatType, { visitChatType } from '@/shared/constants/ChatType';
import BaseModel from '@/shared/models/BaseModel';
import MobilitySolution from '@/shared/models/MobilitySolution';
import Outlet from '@/shared/models/Outlet';
import ReceptionType from '@/shared/models/ReceptionType';
import Tag from '@/shared/models/Tag';
import User from '@/shared/models/User';
import { isAtMidnight } from '@/shared/utils/dateTime';
import Vehicle from '@/vehicle/models/Vehicle';
import BookingProgressCategory from '../constants/BookingProgressCategory';
import BookingStatus from '../constants/BookingStatus';
import BookingItem from './BookingItem';

export interface BookingId {__bookingId: number}

export default class Booking extends BaseModel<BookingId> {
  waitsOnPremise = false;
  tags: Array<Tag> = [];
  unreadMessages = 0;
  pinId: number | null = null;
  bringsDayBefore = false;
  chatId: ChatId | null = null;
  internalChatId: ChatId | null = null;
  dossier: Dossier | null = null;
  appointmentOn: Moment | null = null;
  ownedOn: Moment | null = null;
  owner: User | null = null;
  outlet!: Outlet;
  vehicle: Vehicle | null = null;
  customer: Customer | null = null;
  status = BookingStatus.NEW;
  progressCategory = BookingProgressCategory.REQUESTED;
  mobilitySolution: MobilitySolution | null = null;
  receptionType: ReceptionType | null = null;
  items: Array<BookingItem> = [];

  getChatId(type: ChatType): ChatId | null {
    return visitChatType(type, {
      internal: () => this.internalChatId,
      external: () => this.chatId,
    });
  }

  setChatId(type: ChatType, chatId: ChatId): void {
    visitChatType(type, {
      internal: () => this.internalChatId = chatId,
      external: () => this.chatId = chatId,
    });
  }

  updateWith(data: Partial<Booking>): void {
    Object.assign(this, data);
  }

  updateOutlet(outlet: Outlet): void {
    this.outlet = outlet;
    this.mobilitySolution = null;
  }

  /**
   * Does the customer deliver the vehicle the day before the appointment
   */
  hasPriorDelivery(): boolean {
    if (this.appointmentOn) {
      return isAtMidnight(this.appointmentOn);
    } else {
      return false;
    }
  }
}
